'use client'

import { ElementType, ReactNode, useState } from 'react'

import {
  Candidates,
  Enterprises
} from '@/app/[locale]/(main-layout)/components/ui/Icons'

interface IconMap {
  [key: string]: ElementType
}

export default function Tabs({
  enterpriseTab,
  candidateTab,
  candidateHeader,
  enterpriseHeader,
  tabs
}: {
  enterpriseTab: ReactNode
  candidateTab: ReactNode
  candidateHeader: ReactNode
  enterpriseHeader: ReactNode
  tabs: {
    KEY: string
    NAME: string
    ICON: string
  }[]
}) {
  const [selectedTab, setSelectedTab] = useState(tabs[0]?.KEY)

  return (
    <>
      {selectedTab === 'enterprises' && enterpriseHeader}
      {selectedTab === 'candidates' && candidateHeader}
      <section className="mx-auto mt-8 flex flex-col items-center gap-3">
        <div className="w-full max-w-3xl border-b border-gray-200">
          <nav className="-mb-px flex w-full" aria-label="Tabs">
            {tabs.map((tab) => {
              const icons: IconMap = {
                Enterprises,
                Candidates
              }

              const Icon = icons[tab.ICON as keyof typeof icons] as ElementType

              return (
                <button
                  key={tab.KEY}
                  onClick={() => setSelectedTab(tab.KEY)}
                  className={`${
                    selectedTab === tab.KEY
                      ? 'border-brand-pink/90 font-medium'
                      : 'border-transparent font-light hover:border-gray-300 '
                  } group inline-flex w-full items-center justify-center border-b-2 px-1 py-4 text-sm text-gray-500 hover:text-gray-700`}
                >
                  <Icon
                    className={`${
                      selectedTab === tab.KEY
                        ? 'group-hover:text-gray-700'
                        : 'group-hover:text-gray-700'
                    } -ml-0.5 mr-2 h-5 w-5 text-gray-500`}
                    aria-hidden="true"
                  />
                  <span>{tab.NAME}</span>
                </button>
              )
            })}
          </nav>
        </div>
        {selectedTab === 'enterprises' && enterpriseTab}
        {selectedTab === 'candidates' && candidateTab}
      </section>
    </>
  )
}
